<template>
    <div class="wrapper">
        <!-- 头图 -->
        <header>
            <img :src="ui.head" alt="头图" class="header_img"/>
        </header>
        <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
            <div class="used_form_inner_box">
                <!-- 倒计时 -->
                <!--                <countDown v-if="ui.is_counter" :stime="stime"></countDown>-->

                <div class="top_box" v-if="action_form.checkedBrand == ''">
                    <div class="add_loved_car" @click="clk_brand">
                        <i class="el-icon-plus"></i>
                        添加我的爱车
                    </div>
                </div>
                <div class="middle_box" v-if="action_form.checkedBrand !== ''">
                    <van-field
                        v-model="action_form.checkedBrand"
                        label="我的车型"
                        name="我的车型"
                        placeholder="请选择我的车型"
                        @focus="clk_brand"
                    >
                        <template slot="right-icon">
                            <van-icon name="arrow" @click="clk_brand"/>
                        </template>
                    </van-field>
                    <van-field
                        v-model="action_form.location"
                        readonly
                        label="卖车地区"
                        name="卖车地区"
                        placeholder="请选择卖车地区"
                        @focus="city_show = true"
                    >
                        <template slot="right-icon">
                            <van-icon name="arrow" @click="city_show = true"/>
                        </template>
                    </van-field>

                    <!--2022-10-13  上牌时间前置-->
                    <van-field
                        v-model="action_form.licensing"
                        label="上牌时间"
                        name="上牌时间"
                        placeholder="请选择上牌时间"
                        @focus="clk_licensing"
                    >
                        <template slot="right-icon">
                            <van-icon name="arrow" @click="clk_licensing"/>
                        </template>
                    </van-field>
                </div>
                <div class="bottom_box">
                    <van-field
                        :border="false"
                        v-model="action_form.phone"
                        label="手机号"
                        placeholder="请输入手机号"
                    />
<!--                    <van-field-->
<!--                        :border="false"-->
<!--                        v-model="action_form.code"-->
<!--                        center-->
<!--                        clearable-->
<!--                        label="验证码"-->
<!--                        placeholder="请输入验证码"-->
<!--                    >-->
<!--                        <template #button>-->
<!--                            <span class="span_btn" :disabled="disabled_code" @click="getSms">{{countDown}}</span>-->
<!--                        </template>-->
<!--                    </van-field>-->
                </div>
                <!--协议-->
                <div class="policy_wrapper">
                    <policy_used></policy_used>
                </div>
                <!--提交按钮-->
                <div class="clk_btn"
                     @click="submitForm"
                     :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                    {{ui.btn_text}}
                </div>
            </div>

        </div>
        <div class="detail_img">
            <!-- 详情图-->
            <img :src="ui.tail" alt="详情图" class="detail_img" ref="tailImage"/>
        </div>
        <!-- 版权-->
        <div style="padding-bottom: 40px">
            <copyright v-if="ui.is_copyright"></copyright>
        </div>
        <!-- :style="{display: is_display ? 'none' : 'block'}"-->
        <div v-if="btn_show" class="footer_wrapper">
            <div class="bottom_btn"
                 @click="btn_click_form"
                 :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                {{ui.btn_text}}
            </div>
        </div>
        <!-- 弹框部分-->
        <!-- 车型弹框-->
        <van-popup v-model="is_dialog_car" round
                   position="bottom" :style="{height: '80%',width: '100%'}">
            <usedcar_list :activity_id="Number(activity_id)" :custom_car="Number(custom_car)"
                          :is_dialog_car="is_dialog_car"
                          @query="query_car" @handleClose="handleClose"></usedcar_list>
        </van-popup>
        <!--  城市弹框-->
        <!--  :style="{height: '50%'}" :lock-scroll="false"-->
        <el-dialog
            :visible.sync="city_show"
            v-if="city_show"
            title="精准选择地区，极速匹配服务"
            center
            class="autohome_dialog autohome_dialog_city">

            <el-cascader-panel
                :options="citys"
                :props="cascaderProps"
                @change="change_city"
                ref="sysCascader"
            >
            </el-cascader-panel>
        </el-dialog>

        <!-- 上牌时间选择-->
        <van-popup round v-model="licensing_show" position="bottom"
                   :safe-area-inset-bottom="true"
                   :style="{ height: '50%' }" :close-on-click-overlay="false">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="confirm_licensing"
                @cancel="clk_licensing"
            />
        </van-popup>
        <!-- 报名成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>
    </div>
</template>

<script>
    import countDown from "@/components/countDown";
    import policy_used from "@/components/usedcar/policy_used";
    import copyright from "@/components/copyright";
    import banner from "@/components/banner";
    import usedcar_list from "@/components/usedcar/usedcar_list";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_city from "@/libs/lib_city";
    import _wx from "@/common/_wx";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import lib_success from "@/libs/lib_success";
    import cache_url from "@/cache/cache_url";
    import Toast from "vant/lib/toast";
    import _monitor from "@/monitor/_monitor";

    export default {
        name: "common",
        components: {
            countDown,
            policy_used,
            copyright,
            banner,
            usedcar_list,
        },
        data() {
            return {
                title: '', // document的title
                activity_id: 0, //活动ID
                custom_car: 0, // 是否自定义车型库
                tids: "", //模板ID
                channel: '', //渠道
                channel_name: '', //渠道名
                tid: 0, // 有无车型库
                share_theme: '', //分享描述
                stime: 0, // 项目开始时间
                etime: 0, // 项目结束时间
                ui: {
                    head: '', //头图
                    tail: '', //详情图
                    share: '', //分享图
                    bg_color: '', //表单背景色
                    font_color: '', //文本颜色
                    btn_bg_color: '', //按钮背景色
                    btn_font_color: '', //按钮文本颜色
                    btn_text: '', //按钮文本值
                    btm_btn_text: '', //底部按钮文本
                    is_banner: 0, //是否有轮播图
                    is_counter: 0, //是否有倒计时
                    is_copyright: 1, //协议
                    jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
                },

                action_form: {
                    location: '', //城市信息
                    city_name: '', //城市定位
                    county_id: '',
                    county_name: '',

                    licensing: '', //行驶里程
                    phone: '', //电话
                    code: '', //验证码

                    checkedBrand: '', //车型
                    brand_id: 0,
                    brand_name: '',
                    series_id: 0,
                    series_name: '',
                    product_id: 0,
                    product_name: '',
                },
                //城市联级选择
                city_show: false,
                citys: [], //城市数据
                cascaderProps: { //配置项
                    expandTrigger: 'hover', //展开方式
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "child", //指定选项的子选项
                    emitPath: false, //该节点数组
                },

                is_success: false, //报名成功弹框
                is_city: false, //表单城市项，默认无城市
                is_stop: false, //活动是否已结束
                is_display: true, //底部按钮
                btn_show: false, //底部按钮显隐


                // zhijia
                countDown: '获取验证码', // 倒计时
                disabled_code: false,
                sms_val: '', // 验证码

                // 上牌相关
                licensing_show: false, //上牌时间选择框
                currentDate: undefined,
                minDate: undefined,
                maxDate: new Date(),
                mileage_columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                // 车型弹框
                dialog_header: '',
                is_dialog_car: false,
            }
        },
        created() {
            // 最小年限
            let now = new Date();
            let now1 = new Date();
            const before15 = now.setFullYear((now.getFullYear() - 15));
            this.minDate = new Date(before15);
            // 打开面板默认年
            const middleYear = now1.setFullYear((now1.getFullYear() - 8));
            this.currentDate = new Date(middleYear);

            // 地址栏
            this.activity_id = _geturl("activity_id");
            this.tids = _geturl("tids");
            this.channel = _geturl("channel");
            this.channel_name = _geturl("channel_name");

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            //监测
            _monitor.init(this.channel, this.activity_id);

        },
        mounted() {
            // 监听页面滚动
            window.addEventListener('scroll', this.handleScroll, true)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, true)
        },
        destroyed() {
            // window.removeEventListener('scroll', this.handleScroll())
        },
        methods: {
            //初始化项目信息
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.share_theme = data.activity.share_theme;
                this.etime = data.activity.etime;
                this.stime = data.activity.stime;
                this.tid = data.activity.tid;
                this.custom_car = data.activity.custom_car;
                if(data.ui == null) {
                    this.ui = {};
                    return;
                }
                this.ui = data.ui;

                // 项目结束
                if (!data.activity.state || _time._current() > data.activity.etime) {
                    this.is_stop = true;
                    return;
                }
                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }

                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },

            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },

            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.listx(city, function (data) {
                    that.citys = data;
                })
            },
            countTime() {
                let time = 60  //判断 时间为60s
                let timer = setInterval(() => {
                    if (time === 0) { //  当时间等于 0的时候
                        clearInterval(timer)  //清除时间
                        this.disabled_code = false // 让按钮的样式 为登陆状态
                        this.countDown = '获取验证码'   // 登陆状态的value文本
                        this.action_form.code = '' // 清除掉验证表单的值
                    } else {
                        this.countDown = time + 's'   // 若时间大于则展示重新获取
                        this.disabled_code = true  // 判断显示文本的状态
                        time--  //将时间的一秒秒
                    }
                }, 1000)
            },
            // 获取验证码
            getSms() {
                if (!this.action_form.phone) {
                    Toast('请填写您的手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请填写正确的手机号');
                    return;
                }
                let that = this;
                lib_clue.code(this.action_form.phone,function (data) {
                    that.sms_val = data;
                    that.mobile_val = that.action_form.phone
                })
                this.countTime()

            },
            // 表单提交
            submitForm() {
                //
                if(!this.action_form.checkedBrand) {
                    Toast('请选择车型');
                    return;
                }
                if (!this.action_form.location) {
                    Toast('请选择城市');
                    return;
                }
                if (!this.action_form.licensing) {
                    Toast('请选择行驶里程');
                    return;
                }

                if (!this.action_form.phone) {
                    Toast('请填写您的手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请填写正确的手机号');
                    return;
                }
                // if(
                //     !this.action_form.code
                //     ||this.action_form.code != this.sms_val
                //     ||this.action_form.phone != this.mobile_val){
                //     Toast("验证码不正确");
                //     return;
                // }

                // // 验证码
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;

                let form_extra = {
                    countyId: this.action_form.county_id,
                    countyName: this.action_form.county_name,
                    productId: this.action_form.product_id,
                    productName: this.action_form.product_name,
                }
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    url: url,
                    location: this.action_form.city_name,
                    form_extra: JSON.stringify(form_extra),
                    form_phone: this.action_form.phone,
                    form_series: this.action_form.series_name,
                    form_brand: this.action_form.brand_name,
                    form_licensing: this.action_form.licensing,
                    form_ui_id,
                };
                let that = this;
                // return;
                lib_clue.receive(params, function (data) {
                    //监测上报
                    _monitor.submit()

                    //缓存当页面链接
                    cache_url.set(window.location.href)
                    //跳转 二手车的成功跳转 todo
                    // setTimeout(() => {
                    // }, 2000);
                    //不同参数跳转不同页面
                    const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 3
                    //跳转地址
                    const url = lib_success.jmp_url(jmp_url)
                    that.$router.push({
                        path: url,
                        query: {
                            id: data.id
                        },
                    })
                })
            },

            // 滚到表单开始部分
            btn_click_form() {
                let form_top = this.$refs.main.offsetTop - 50;
                document.documentElement.scrollTop = form_top
                document.body.scrollTop = form_top;
                document.querySelector('#app').scrollTop = form_top
            },
            // 滚动
            handleScroll() {
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
                this.$nextTick(() => {
                    if (scrollHeight >= this.$refs.tailImage.offsetTop) {
                        this.is_display = false;
                        this.btn_show = true;
                    } else {
                        this.is_display = true;
                        this.btn_show = false;
                    }
                })
            },
            /*城市相关*/
            change_city() {
                let pathvalue = this.$refs.sysCascader.getCheckedNodes()[0];

                let countyId = pathvalue.value;
                let countyName = pathvalue.label;
                let cityName = pathvalue.parent.label

                if(countyId || countyName){
                    this.action_form.county_id = countyId
                    this.action_form.county_name = countyName;
                    this.action_form.city_name = cityName;
                    this.action_form.location = cityName + '-' + countyName;
                    this.city_show = false
                }
            },
            //获取品牌车型
            clk_brand() {
                this.is_dialog_car = true;
                document.activeElement.blur();
            },
            query_car(brand_id, brand_name, series_id, series_name,product_id,product_name) {
                this.action_form.brand_id = brand_id
                this.action_form.brand_name = brand_name
                this.action_form.series_id = series_id
                this.action_form.series_name = series_name
                this.action_form.product_id = product_id
                this.action_form.product_name = product_name

                this.action_form.checkedBrand = brand_name + ',' + series_name + ',' + product_name;
                this.is_dialog_car = false;
            },
            handleClose(flag) {
                this.is_dialog_car = flag;
            },

            // 对时间进行格式化处理
            formatter(time) {
                let year = time.getFullYear();
                let month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
                return year + '-' + month
            },
            //上牌时间
            clk_licensing() {
                document.activeElement.blur();
                this.licensing_show = !this.licensing_show;
            },
            // 时间选择完成
            confirm_licensing(values) {
                this.action_form.licensing = this.formatter(new Date(values));
                this.clk_licensing();
            },

        },
        watch: {
            is_dialog_car(val) {
                let scrollWidth = document.innerWidth - document.documentElement.offsetWidth;
                if (val) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.paddingRight = scrollWidth + 'px'
                } else {
                    document.body.style.overflow = 'scroll';
                    document.body.style.paddingRight = scrollWidth + 'px'
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    @import "../../assets/style/autoshow/base.less";
    @import "../../assets/style/autoshow/form.less";
    // 二手车的form
    @import "../../assets/style/usedcar/autohome/form.less";
    // form
    @import "../../assets/style/common/successful.less"; //报名成功

    // 三级城市弹框
    @import "../../assets/style/usedcar/autohome/dialog.less";
    /deep/ .van-field__label{
        margin-right: 0px;
    }
</style>


